import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldRichText, FieldSelect, FieldText } from '@dixa/lib-shared-habla';
import * as React from 'react';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';
import { SanitizeHTML } from 'app/utils/htmlSanitizer';
import { LanguageCustomizationForm } from '../../types';
import style from './index.module.scss';
const ratingStyles = ['emojis', 'numbers', 'stars'];
const ratingStyleOptions = ratingStyles.map((style) => ({
    id: style,
    name: style,
}));
const availableTemplateVariables = `You can use these replacing variables eg. *{{email_sender_name}}* with the actual email name.:\n\n` +
    `{{organization_name}}\n
    {{requester_firstname}}\n
    {{requester_fullname}}\n
    {{requester_email}}\n
    {{email_sender_name}}\n
    {{conversation_subject}}\n
    {{csid}}\n\n` +
    `_note_: csid is the conversation ID.`;
export const EmailCustomizationFormView = (props) => {
    return (_jsxs("section", { children: [_jsx(Field, { name: LanguageCustomizationForm.Fields.subject, placeholder: "Email subject", validate: [required()], label: "Email subject line", component: FieldText, helpIconText: `This field is used to fill out the subject line in emails when composing emails and for auto-replies. ${availableTemplateVariables}` }), _jsx(Field, { className: style.richTextInput, name: LanguageCustomizationForm.Fields.body, placeholder: "Email body", validate: [required()], label: "Email body text", component: FieldRichText, helpIcon: { text: availableTemplateVariables }, sanitize: SanitizeHTML.sanitizerForProfile('email') }), _jsx(Field, { name: LanguageCustomizationForm.Fields.ratingQuestion, placeholder: "Rating question", validate: [required()], label: "Rating question", component: FieldText }), _jsx(Field, { name: LanguageCustomizationForm.Fields.ratingStyle, placeholder: "Rating style", validate: [required()], label: "Rating style", component: FieldSelect, items: ratingStyleOptions })] }));
};
